import { Box, Container, Grid, Typography, Skeleton, Select, MenuItem } from "@mui/material";
import { CustomBox, CustomButton, TitleBar } from '../../../components';
import visaImage from './../../../assets/visa.png';
import masterImage from './../../../assets/master.png';
import { infoGlobal } from "../../../api/infoGlobal";
import React, { useEffect, useState } from "react";
import { GuardarInfoTarjetas, LoadingModalProps, ProductoSeleccionado } from "../../../models";
import { useSelector } from "react-redux";
import { AppStore } from "../../../redux/stores";
import { useNavigate } from "react-router-dom";
import { onboardingTarjetasApi } from "../../../api/onboardingTarjetas";
import { PrivateRoutes, PublicRoutes } from "../../../routes";
import { useDispatch } from 'react-redux';
import { setError } from "../../../redux/states/error";
//import { setError } from "../../../redux/states/appMobile";
import { createUser } from "../../../redux/states/user";

interface Producto {
  tipo_producto: string;
  marca: string;
  montoMax: number;
  montoMin: number;
  imagen?: string;
}

interface Datos {
  productos: Producto[];
  nombre: string;
  apellido: string;
}

interface PreInfo {
  resultado: boolean;
  errores: string;
  datos: Datos;
}

const PreInfoVacio: PreInfo = {
  resultado: false,
  errores: "",
  datos: {
    productos: [],
    nombre: "",
    apellido: ""
  }
};

interface TarjetasProps {
  onLoadingModalPrivate: (value: LoadingModalProps) => void;
}

const Tarjetas: React.FC<TarjetasProps> = ({ onLoadingModalPrivate }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tarjetas = useSelector((state: AppStore) => state.product);

  //Recuperar el idTramite
  let userIdTramite = useSelector((state: AppStore) => state.user.idTramite);
  //Solo para pruebas, eliminar o comentar antes de salir a producción
  // if (!userIdTramite || userIdTramite.trim() === "") {
  //   userIdTramite = "2af9c594-3bb4-4ef0-bb39-19494723c56a";
  //   dispatch(createUser({
  //       idTramite: userIdTramite,
  //       name: "",
  //       surname: "",
  //       cuit: "",
  //       dnn: "",
  //       telefono: ""
  //   }));
  // }

  const [datosRespuesta, setDatosRespuesta] = React.useState<PreInfo>(PreInfoVacio);

  //Datos que entrega la API
  const [apellido, setApellido] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [selectedCard, setSelectedCard] = useState<string | null>(null);
  const [skeletonCarga, setSkeletonCarga] = useState<boolean>(true);
  const [openSnack, setopenSnack] = useState({ open: false, message: "" });
  const [habilitarContinuar, setHabilitarContinuar] = React.useState<boolean>(true);

  const [visaProducts, setVisaProducts] = useState<Producto[]>([
    { tipo_producto: "Visa", marca: "Visa", montoMax: 0, montoMin: 0 }
  ]);

  const [mcProducts, setMcProducts] = useState<Producto[]>([
    { tipo_producto: "MasterCard", marca: "MasterCard", montoMax: 0, montoMin: 0 }
  ]);

  const [selectedMcProduct, setSelectedMcProduct] = React.useState<unknown>("no-product");
  const [selectedVisaProduct, setSelectedVisaProduct] = React.useState<unknown>("no-product");

  const handleCloseSnack = () => setopenSnack({ open: false, message: "" });

  useEffect(() => {
    setSkeletonCarga(true);
    onLoadingModalPrivate({ openLM: true, messageLM: "Cargando opciones de tarjetas..." });

    setDatosRespuesta(PreInfoVacio);

    onboardingTarjetasApi
      .preInfoTarjetas(userIdTramite)
      .then((response) => {
        console.log("preInfoTarjeta: " + response.data);
        setDatosRespuesta(response.data);
        //mock para bypass -> comentar o borrar cuando se vaya a pasar a dev, test o prd
        //const obj = '{"resultado":true,"errores":{},"datos":{"productos":[{"tipo_producto":"ESTÁNDAR - Visa Gold","marca":2,"montoMax":5000000,"montoMin":100000},{"tipo_producto":"Alta Digital Visa Signature","marca":2,"montoMax":7000000,"montoMin":5000000}],"nombre":"PEREZ JOSCELIS DEL VALLE","apellido":"SALAZAR", "esCorto": true, "msjCustom": ""}}';
        //response.data = JSON.parse(obj);  
        // //borrar esta linea de abajo
        //setDatosRespuesta(response.data);
        if (response.data.resultado == true) {
          if (response.data.datos.productos.length > 0) {
            const visa = (response.data.datos.productos as Producto[]).filter((producto) =>
              producto.tipo_producto.toLowerCase().includes("visa")
            );
            const mc = (response.data.datos.productos as Producto[]).filter((producto) =>
              producto.tipo_producto.toLowerCase().includes("mc")
            );
            setVisaProducts(visa);
            setMcProducts(mc);
            
            if (visa.length > 0) {
              setSelectedVisaProduct(visa[0].tipo_producto);
            }
            
            setSkeletonCarga(false);
            onLoadingModalPrivate({ openLM: false, messageLM: "" });
          } else {
            onLoadingModalPrivate({ openLM: false, messageLM: "" });
            navigate(`/${PublicRoutes.SINPRODUCTOS}`, { replace: true });
          }
        } else {
          console.error(response.data.errores);
          dispatch(
            setError({
              idError: response.data.errores.idError,
              mensaje: response.data.errores.mensaje,
            })
          );
          handleError("No pudimos encontrar ninguna oferta de tarjetas.");
        }
      })
      .catch((error) => {
        if (error.response) {
          const statusCode = error.response.status;
          const statusMessage = error.response.statusText;

          console.error("Error Status Code:", statusCode);
          console.error("Error Status Message:", statusMessage);

          dispatch(
            setError({
              idError: statusCode.toString() || "54",
              mensaje: statusMessage || "Error desconocido del servidor",
            })
          );

          setopenSnack({
            open: true,
            message: "No pudimos encontrar ninguna oferta de tarjetas.",
          });
        } else if (error.request) {
          // No se recibió respuesta del servidor
          console.error("No response from server:", error.request);

          dispatch(
            setError({
              idError: "54",
              mensaje: "No pudimos encontrar ninguna oferta de tarjetas.",
            })
          );

          setopenSnack({
            open: true,
            message: "No pudimos encontrar ninguna oferta de tarjetas.",
          });
        } else {
          // Error al configurar la solicitud
          console.error("Error setting up the request:", error.message);

          dispatch(
            setError({
              idError: "54",
              mensaje: "Hubo un error al procesar la solicitud. Intente nuevamente.",
            })
          );

          setopenSnack({
            open: true,
            message: "No pudimos encontrar ninguna oferta de tarjetas.",
          });
        }

        setSkeletonCarga(false);
        onLoadingModalPrivate({ openLM: false, messageLM: "" });
        handleError("No pudimos encontrar ninguna oferta de tarjetas.");
      });
  }, []);


  const handleError = (message: string) => {
    onLoadingModalPrivate({ openLM: true, messageLM: message });
    setTimeout(() => {
      setSkeletonCarga(true);
      onLoadingModalPrivate({ openLM: false, messageLM: "" });
      navigate(`/${PublicRoutes.ERROR}`, { replace: true });
    }, 2000);
  };

  function guardarInfoTarjetas() {
    onLoadingModalPrivate({ openLM: true, messageLM: "Guardando Información" });

    let productoSeleccionado: ProductoSeleccionado[] = [];

    if (tarjetas === 1 && selectedMcProduct) { //Solo MC
      const mcProduct = mcProducts.find(
        (product) => product.tipo_producto === selectedMcProduct
      );
      if (mcProduct) {
        productoSeleccionado.push({
          tipo_producto: mcProduct.tipo_producto
        });
      }
    } else if (tarjetas === 2 && selectedVisaProduct) { //Solo Visa
      const visaProduct = visaProducts.find(
        (product) => product.tipo_producto === selectedVisaProduct
      );
      if (visaProduct) {
        productoSeleccionado.push({
          tipo_producto: visaProduct.tipo_producto
        });
      }
    } else if (tarjetas === 3) { //AMBAS
      if (selectedMcProduct) {
        const mcProduct = mcProducts.find(
          (product) => product.tipo_producto === selectedMcProduct
        );
        if (mcProduct) {
          productoSeleccionado.push({
            tipo_producto: mcProduct.tipo_producto
          });
        }
      }

      if (selectedVisaProduct) {
        const visaProduct = visaProducts.find(
          (product) => product.tipo_producto === selectedVisaProduct
        );
        if (visaProduct) {
          productoSeleccionado.push({
            tipo_producto: visaProduct.tipo_producto
          });
        }
      }
    }

    const datos: GuardarInfoTarjetas = {
      productoSeleccionado,
      idtramite: userIdTramite,
    };

    console.log(`Datos a guardar: ${JSON.stringify(datos)}`)

    onboardingTarjetasApi
      .saveInfoTarjetas(datos)
      .then((response) => {
        console.log(response.data);
        if (response.data.resultado) {
          if(response.data.datos.esCorto != null && response.data.datos.esCorto != undefined && response.data.datos.esCorto != "" && response.data.datos.esCorto){
            const msjCustom = response.data.datos.msjCustom != null || response.data.datos.msjCustom != "" ? response.data.datos.msjCustom : "";
            onLoadingModalPrivate({ openLM: false, messageLM: "" });
            navigate(`/${PrivateRoutes.PRIVATE}/${PrivateRoutes.APPMOBILE}`, {
              state: { msjCustom }
            });
          }else{
            onLoadingModalPrivate({ openLM: false, messageLM: "" });
            navigate(`/${PrivateRoutes.PRIVATE}/${PrivateRoutes.DATOSPEROSANLES}`, {
              replace: true,
          });
          }
        } else {
          dispatch(
            setError({
              idError: response.data.errores.idError,
              mensaje: response.data.errores.mensaje,
            })
          );
          console.error(response.data.errores);
          onLoadingModalPrivate({ openLM: false, messageLM: "" });
          setopenSnack({
            open: true,
            message: "Hubo un error al guardar la información de la tarjeta, redirigiendo al inicio.",
          });
          handleError("Hubo un error al guardar la información de la tarjeta, redirigiendo al inicio.");
        }
      })
      .catch((error) => {
        if (error.response) {
          const statusCode = error.response.status;
          const statusMessage = error.response.statusText;

          console.error("Error Status Code:", statusCode);
          console.error("Error Status Message:", statusMessage);

          dispatch(
            setError({
              idError: statusCode.toString(),
              mensaje: statusMessage || "Error desconocido del servidor",
            })
          );

          setopenSnack({
            open: true,
            message: "Hubo un error al guardar la información de la tarjeta, redirigiendo al inicio.",
          });
        } else if (error.request) {
          // No se recibió respuesta del servidor
          console.error("No response from server:", error.request);

          dispatch(
            setError({
              idError: "0",
              mensaje: "No se recibió respuesta del servidor. Verifique su conexión a Internet.",
            })
          );

          setopenSnack({
            open: true,
            message: "Hubo un error al guardar la información de la tarjeta, redirigiendo al inicio.",
          });
        } else {
          // Error al configurar la solicitud
          console.error("Error setting up the request:", error.message);

          dispatch(
            setError({
              idError: "0",
              mensaje: "Hubo un error al procesar la solicitud. Intente nuevamente.",
            })
          );

          setopenSnack({
            open: true,
            message: "Hubo un error al guardar la información de la tarjeta, redirigiendo al inicio.",
          });
        }

        onLoadingModalPrivate({ openLM: false, messageLM: "" });
        handleError("Hubo un error al guardar la información de la tarjeta, redirigiendo al inicio.");
      });
  }

  const SkeletonDiv = () => {
    return (
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Título de la tarjeta */}
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="text" width={100} height={40} />
        </Box>

        {/* Imagen de la tarjeta */}
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="rounded" width={250} height={150} sx={{ borderRadius: "15px" }} />
        </Box>

        {/* Detalles de la tarjeta */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            gap: 2, // Combina rowGap y columnGap
            alignItems: "center",
            justifyContent: "center", // Asegura que el contenido del grid esté centrado
            mt: 2,
          }}
        >
          {/* Límite de crédito */}
          <Skeleton
            variant="text"
            sx={{
              width: { xs: 80, md: 120 },
              height: { xs: 30, md: 40 },
            }}
          />
          <Skeleton
            variant="rounded"
            sx={{
              width: { xs: 200, md: 250 },
              height: { xs: 30, md: 40 },
            }}
          />

          {/* Producto */}
          <Skeleton
            variant="text"
            sx={{
              width: { xs: 80, md: 120 },
              height: { xs: 30, md: 40 },
            }}
          />
          <Skeleton
            variant="rounded"
            sx={{
              width: { xs: 200, md: 250 },
              height: { xs: 30, md: 40 },
            }}
          />
        </Box>
      </Box>
    );
  };

  const renderTarjetas = () => {
    if (skeletonCarga) {
      // Renderizar SkeletonDiv mientras se cargan las tarjetas
      return (
        <>
          {[...Array(tarjetas !== 3 ? 1 : 2)].map((_, index) => (
            <Grid item xs={12} sm={6} key={`skeleton-${index}`}>
              <SkeletonDiv />
            </Grid>
          ))}
        </>
      );
    }

    return (
      <>
        {mcProducts.length > 0 && (
          <Grid item xs={12} sm={6} key="master">
            <Box textAlign="center">
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                MasterCard
              </Typography>
              {mcProducts[0].imagen ? (
                <Box
                  component="img"
                  src={`data:image/png;base64,${mcProducts[0].imagen}`}
                  alt="MasterCard Card"
                  sx={{ width: "100%", maxWidth: "250px", height: "auto", my: 2 }}
                />
              ) : (
                <Box
                  component="img"
                  src={masterImage}
                  alt="MasterCard"
                  sx={{ width: "100%", maxWidth: "250px", height: "auto", my: 2 }}
                />
              )}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "auto 1fr",
                  rowGap: 2,
                  columnGap: 1,
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", textAlign: "left" }}
                >
                  Límite de crédito:
                </Typography>
                <CustomBox
                  text={`$ ${new Intl.NumberFormat("es-AR", {
                    minimumFractionDigits: 0,
                  }).format(mcProducts[0]?.montoMax || 0)}`}
                />

                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", textAlign: "left" }}
                >
                  Producto:
                </Typography>
                <Select
                  value={selectedMcProduct}
                  onChange={(event) => {
                    setSelectedMcProduct(event.target.value);
                  }}
                  size="small"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "25px",
                    border: "2px solid #000000",
                    width: "100%",
                    color: "#000000 !important",
                    textAlign: "center",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiSelect-select": {
                      padding: "12px 16px",
                      color: "#000000 !important",
                      fontSize: "16px",
                      fontWeight: 400,
                      textAlign: "center",
                    },
                    "& .MuiInputBase-input": {
                      color: "#000000 !important",
                      textAlign: "center",
                    },
                    "& .MuiSvgIcon-root": {
                      display: "none",
                    },
                  }}
                >
                  <MenuItem value="no-product">Seleccioná un producto</MenuItem>
                  {mcProducts.map((p, index) => (
                    <MenuItem 
                      key={`mc-product-${index}`} 
                      value={p.tipo_producto}
                    >
                      {p.tipo_producto}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
          </Grid>
        )}

        {visaProducts.length > 0 && (
          <Grid item xs={12} sm={6} key="visa">
            <Box textAlign="center">
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                VISA
              </Typography>
              {visaProducts[0].imagen ? (
                <Box
                  component="img"
                  src={`data:image/png;base64,${visaProducts[0].imagen}`}
                  alt="VISA Card"
                  sx={{ width: "100%", maxWidth: "250px", height: "auto", my: 2 }}
                />
              ) : (
                <Box
                  component="img"
                  src={visaImage}
                  alt="VISA"
                  sx={{ width: "100%", maxWidth: "250px", height: "auto", my: 2 }}
                />
              )}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "auto 1fr",
                  rowGap: 2,
                  columnGap: 1,
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", textAlign: "left" }}
                >
                  Producto:
                </Typography>
                <Select
                  value={selectedVisaProduct}
                  onChange={(event) => {
                    setSelectedVisaProduct(visaProducts[0].tipo_producto);
                  }}
                  size="small"
                  disabled
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "25px",
                    border: "2px solid #000000",
                    width: "100%",
                    color: "#000000 !important",
                    textAlign: "center",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-disabled": {
                      color: "#000000 !important",
                      WebkitTextFillColor: "#000000 !important",
                    },
                    "& .MuiSelect-select": {
                      padding: "12px 16px",
                      color: "#000000 !important",
                      fontSize: "16px",
                      fontWeight: 400,
                      textAlign: "center",
                      WebkitTextFillColor: "#000000 !important",
                    },
                    "& .MuiInputBase-input": {
                      color: "#000000 !important",
                      textAlign: "center",
                      WebkitTextFillColor: "#000000 !important",
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      color: "#000000 !important",
                      WebkitTextFillColor: "#000000 !important",
                    },
                    "& .MuiSvgIcon-root": {
                      display: "none",
                    },
                  }}
                >
                  <MenuItem value="no-product">Seleccioná un producto</MenuItem>
                  {visaProducts.map((p, index) => (
                    <MenuItem 
                      key={`visa-product-${index}`} 
                      value={p.tipo_producto}
                    >
                      {p.tipo_producto}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
          </Grid>
        )}
      </>
    );
  };


  return (
    <Container maxWidth="md" sx={{ bgcolor: '#FFFFFF', p: 2, mt: 4 }}>
      {/* Título de información */}
      <Grid item xs={12}>
        <TitleBar text="Información de la operación" />
      </Grid>

      {/* Saludo y subtítulo */}
      <Box sx={{ p: 3, textAlign: 'center' }}>
        {skeletonCarga ? (
          // Renderizar un Skeleton mientras se cargan los datos
          <Skeleton variant="text" width="60%" height={40} sx={{ mx: 'auto' }} />
        ) : (
          // Mostrar el contenido cuando skeletonCarga sea false
          <Typography variant="h5">
            ¡Hola <strong>{`${datosRespuesta?.datos?.apellido || ''} ${datosRespuesta?.datos?.nombre || ''}`}</strong>! Tenemos la siguiente oferta para vos:
          </Typography>
        )}
      </Box>

      {/* Contenedor de tarjetas */}
      <Grid container spacing={4} justifyContent="center">
        {renderTarjetas()}
      </Grid>

      {/* Botón de continuar */}
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <CustomButton
          text="Continuar"
          onClick={guardarInfoTarjetas}
          disabled={(() => {
            if (tarjetas === 1) {
              return selectedMcProduct === "no-product";
            } else if (tarjetas === 2) {
              return selectedVisaProduct === "no-product";
            } else if (tarjetas === 3) {
              return selectedMcProduct === "no-product" || selectedVisaProduct === "no-product";
            }
            return true;
          })()}
        />
      </Box>
    </Container>
  );
};

export default Tarjetas;
